import { render, staticRenderFns } from "./OrganisationTypes.vue?vue&type=template&id=183842e2&scoped=true&"
import script from "./OrganisationTypes.vue?vue&type=script&lang=js&"
export * from "./OrganisationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183842e2",
  null
  
)

export default component.exports